import { Identifier } from "../../core";
export class PackagingContainerTypeId extends Identifier {
    constructor(id) {
        super("PackagingContainerTypeId", id);
    }
}
